import { Stack } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export default function TooltipLabelList({ labelList }) {
  if (!Array.isArray(labelList) || labelList?.length === 0) return null;

  return (
    <Stack>
      {labelList.map(({ id, displayName }) => (
        <TextBodyMedium key={id} color="#FFF">
          {displayName}
        </TextBodyMedium>
      ))}
    </Stack>
  );
}
